





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Date: () => import('../date'),
    Block: () => import('../block'),
  },
})
export default class Card extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly noborder!: boolean;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: String, default: '' })
  readonly noFormatDate!: string;

  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: Boolean, default: true })
  readonly showAddition: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/compopnents/card/Card.vue